import store from '../../store'
import { ordersInitialState } from '../../reducer/orders.reducer'

let paperEl: HTMLElement | null = null
let pendingVisible = false

const isQuickTradeOpenInStore = () => {
    const quickOrder = store.getState().ordersStore?.quickOrder ?? ordersInitialState.quickOrder
    const type = quickOrder?.type ?? 'trade'
    return Boolean(quickOrder?.openDialog) && (type === 'trade' || type === 'modify')
}

const applyVisible = (el: HTMLElement) => {
    el.style.visibility = 'visible'
    el.style.pointerEvents = 'auto'
}

const applyHidden = (el: HTMLElement) => {
    el.style.visibility = 'hidden'
    el.style.pointerEvents = 'none'
}

export const registerQuickTradePaper = (el: HTMLElement | null) => {
    paperEl = el
    if (!el) return
    if (pendingVisible || isQuickTradeOpenInStore()) {
        applyVisible(el)
    } else {
        applyHidden(el)
    }
}

export const showQuickTradePaperInstant = () => {
    pendingVisible = true
    if (paperEl) {
        applyVisible(paperEl)
    }
}

export const hideQuickTradePaperInstant = () => {
    pendingVisible = false
    if (paperEl) {
        applyHidden(paperEl)
    }
}

export const syncQuickTradePaperVisibility = () => {
    if (!paperEl) return
    if (pendingVisible || isQuickTradeOpenInStore()) {
        applyVisible(paperEl)
    } else {
        applyHidden(paperEl)
    }
}
